/**
 * Represents the status of an asynchronous request.
 *
 * @template T - The type of the target identifier or payload used for request tracking.
 */
export interface IRequestStatus<T> {
  requesting: boolean;
  requestingId?: T;
  requestedId?: T;
  error: boolean;
  errorText?: string;
  cancel?: () => void;
}

export interface IAxiosReturnSuccess<T> {
  success: true;
  data: T;
}

export interface IAxiosReturnFail {
  success: false;
  errorText: string;
}

export type IAxiosBlankReturn = IAxiosReturnFail | { success: true };
export type IAxiosReturn<T> = IAxiosReturnSuccess<T> | IAxiosReturnFail;

/**
 * Return shape for validation functions.
 */
export type IValidReturnSuccess = IAxiosReturnSuccess<{ valid: boolean; validationText: string }>;
export type IValidReturn = IAxiosReturnFail | IValidReturnSuccess;

/**
 * Optional context values that validation functions can use alongside the primary target value.
 */
export interface IValidationTargetOptions {
  previousValue?: string;
  existingValues?: string[];
  otherValues?: Record<string, string>;
}

/**
 * Target shape passed to validation functions.
 */
export interface IValidationTarget {
  value: string;
  options?: IValidationTargetOptions;
}

/**
 * Validation function type used by Control components.
 */
export type IValidationFunction = (
  backEndUrl: string,
  target: IValidationTarget,
  controller: AbortController,
) => Promise<IValidReturn>;
